import React from "react";
import { render } from "react-dom";
import App from "./App";
import "./css/styles.css";
import "./css/themes.css";
import "./css/print.css";
import "react-tabs/style/react-tabs.css";
render(<App />, document.getElementById("root"));
